(function () {
  'use strict';

  function init(root) {
    if (root.dataset.pcInit === '1') return;
    root.dataset.pcInit = '1';

    var track = root.querySelector('[data-pcarousel-track]');
    var prev = root.querySelector('[data-pcarousel-prev]');
    var next = root.querySelector('[data-pcarousel-next]');

    // Okları görsel (media) hizasına ortala
    function measure() {
      var media = root.querySelector('.pcard__media');
      if (media) root.style.setProperty('--pcard-media-h', media.getBoundingClientRect().height + 'px');
    }

    function update() {
      if (!track) return;
      var max = track.scrollWidth - track.clientWidth - 1;
      var overflow = max > 2;
      if (prev) prev.hidden = !overflow || track.scrollLeft <= 2;
      if (next) next.hidden = !overflow || track.scrollLeft >= max;
    }

    function step(dir) {
      track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' });
    }

    if (next) next.addEventListener('click', function () { step(1); });
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (track) track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', function () { measure(); update(); });

    measure();
    update();
    window.addEventListener('load', function () { measure(); update(); });
    setTimeout(function () { measure(); update(); }, 500);
  }

  function initAll() {
    document.querySelectorAll('[data-pcarousel]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-pcarousel]');
    if (el) init(el);
  });
})();
